(function () {
  var cta = document.getElementById("floatCta");
  if (!cta) return;

  var lastScrollY = window.scrollY;

  window.addEventListener(
    "scroll",
    function () {
      var currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        // 下スクロール中 → 表示
        cta.classList.add("is-visible");
      } else {
        // 上スクロール中 → 非表示
        cta.classList.remove("is-visible");
      }

      lastScrollY = currentScrollY;
    },
    { passive: true },
  );
})();
